import axios from 'axios';
import { fetch as fetchPolyfill } from 'whatwg-fetch';
import * as urls from '../actions/urlTypes';
import { EXPRESSIONS_BREADCRUMBS_LIST, 
  UPDATE_CROSSTAB_TITLE_HEADER, 
  EXPRESSIONS_DETAILS_LIST } from '../actions/actionTypes';
import { MOVE_TO_ROW_FROM_SCRATCH, MOVE_TO_BASE_FROM_SCRATCH,
  MOVE_TO_COLUMN_FROM_SCRATCH, COPY_TO_COLUMN_FROM_SCRATCH,
  COPY_TO_ROW_FROM_SCRATCH, COPY_TO_BASE_FROM_SCRATCH,
  MOVE_TO_ROW_FROM_QUESTION, MOVE_TO_BASE_FROM_QUESTION,
  MOVE_TO_COLUMN_FROM_QUESTION, ADD_SMARTSEARCH_GRID_ROW,
  ADD_SMARTSEARCH_GRID_COLUMN, ADD_SMARTSEARCH_GRID_BASE,
  ADD_DICTIONARY_DATA_GRID_COLUMN, ADD_DICTIONARY_DATA_GRID_BASE,
  ADD_DICTIONARY_DATA_GRID_ROW, MOVE_TO_ROW_FROM_CRB,
  MOVE_TO_BASE_FROM_CRB, MOVE_TO_COLUMN_FROM_CRB, COPY_TO_COLUMN_FROM_CRB,
  COPY_TO_ROW_FROM_CRB, COPY_TO_BASE_FROM_CRB, TOOL_GRID_BASE_EDIT,
  TOOL_GRID_COLUMN_EDIT, TOOL_GRID_ROW_EDIT, TOOL_TARGET_EDIT_CLICK,
  ACTION_TYPE_SCRATCH, ACTION_TYPE_CRGBGRIDMENU, ACTION_TYPE_QUESTION,
  ACTION_TYPE_CUSTOM_DROPDOWN, ACTION_TYPE_CRGB_GRIDS, ACTION_TYPE_TOOL_GRID,
  SELECT_ALL_ITEMS_FROM_SCRATCH, DELETE_SCRATCH_FROM_SCRATCH,
  ADD_TO_DEFINITION_FROM_SCRATCH, FUNCTIONS_MENU_FROM_SCRATCH,
  ADD_DATAPOINT_TO_SCRATCH, CROSSTAB_FEATUREID, CROSSTAB_CONSTANT,
} from '../constants';
import { MANAGE_USER_STATE_POPUP, IS_USER_STATE_POPUP_SHOWN } from '../actions/actionTypes';
import { updateModuleStudy, updateWeightType } from '../actions/studyActions';
import { getSampleWeighted, fetchStandardBaseList, updateToggleLabelFlag } from '../actions/crosstabActions';
import { getStudyFromStudies, filterStudyList } from './CommonUtils';
import { divideJointExpressions } from './autocodeUtils';

const moment = require('moment-timezone');

export const saveTrackingData = ({
    uid,
    accid,
    moduleName,
    subModule,
    action,
    productNo,
    attributes,
    loginCall = false,
    triggerTrackCall = false,
  }) => {
  if (urls.USAGE_TRACKING_ENABLED) {
    if (!loginCall) {
      const timeZone = moment.tz(new Date().getTime(), 'America/Chicago');
      const formattedTime = timeZone.format('YYYY-MM-DD HH:mm:ss');
      const newArray = [];
      newArray.push({
        userId: uid,
        accountId: accid,
        productNo,
        module: moduleName,
        subModule,
        event: action,
        timestamp: formattedTime,
        attributes,
      });
      if (window.trackingDataLayer.length < 9 && !triggerTrackCall) {
        window.trackingDataLayer.push(newArray[0]);
      } else {
        window.trackingDataLayer.push(newArray[0]);
        fetchPolyfill(`${urls.API_GATEWAY_URL}${urls.USAGE_TRACKER_API_URL}`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(window.trackingDataLayer),
        }).then(() => {}).catch(error => console.warn(error));
        window.trackingDataLayer = [];
      }
    } else if (loginCall && window.trackingDataLayer.length > 0) {
      fetchPolyfill(`${urls.API_GATEWAY_URL}${urls.USAGE_TRACKER_API_URL}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(window.trackingDataLayer),
      }).then(() => {}).catch(error => console.warn(error));
      window.trackingDataLayer = [];
    }
  }
};

export const saveSearchTrackingData = ({
  uid,
  accid,
  moduleName,
  subModule,
  productNo,
  textSearched,
  textSelected,
  detail,
}) => {
  if (`${urls.API_GATEWAY_URL}${urls.SEARCH_USAGE_TRACKER_API_URL}`) {
    const timeZone = moment.tz(new Date().getTime(), 'America/Chicago');
    const formattedTime = timeZone.format('YYYY-MM-DD HH:mm:ss');
    const newArray = [];
    if (moduleName === undefined) {
      moduleName = 'Crosstab';
    }
    if (moduleName === 'insight360') {
      moduleName = 'BrandCatalyst';
    }

    if (subModule === 'COMPETITION') {
      subModule = 'COMPARE';
    }

    newArray.push({
      userId: uid,
      accountId: accid,
      productNo,
      module: moduleName.toUpperCase(),
      subModule,
      timestamp: formattedTime,
      textSearched,
      textSelected,
      detail,
    });

    fetchPolyfill(`${urls.API_GATEWAY_URL}${urls.SEARCH_USAGE_TRACKER_API_URL}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newArray),
    }).then(() => {}).catch(error => console.warn(error));
  }
};

export const saveErrorDetails = ({
  accountId,
  app,
  moduleName,
  subModule,
  productNo,
  detail,
}) => {
  const timeZone = moment.tz(new Date().getTime(), 'America/Chicago');
  const formattedTime = timeZone.format('YYYY-MM-DD HH:mm:ss:SSS');
  const newArray = [];

  newArray.push({
    productNo,
    accountId,
    app,
    module: moduleName.toUpperCase(),
    subModule,
    timestamp: formattedTime,
    detail,
  });

  fetchPolyfill(`${urls.API_GATEWAY_URL}${urls.USAGE_TRACKER_ERROR_URL}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(newArray),
  }).then(() => {}).catch(error => console.warn(error));
};

export const getActionName = (page, action) => {
  switch (page) {
    case ACTION_TYPE_SCRATCH: {
      switch (action) {
        case 'Move to Rows': action = MOVE_TO_ROW_FROM_SCRATCH; break;
        case 'Move to Bases': action = MOVE_TO_BASE_FROM_SCRATCH; break;
        case 'Move to Columns': action = MOVE_TO_COLUMN_FROM_SCRATCH; break;
        case 'Copy to Columns': action = COPY_TO_COLUMN_FROM_SCRATCH; break;
        case 'Copy to Rows': action = COPY_TO_ROW_FROM_SCRATCH; break;
        case 'Copy to Bases': action = COPY_TO_BASE_FROM_SCRATCH; break;
        case 'Select All Items': action = SELECT_ALL_ITEMS_FROM_SCRATCH; break;
        case 'Delete Scratch': action = DELETE_SCRATCH_FROM_SCRATCH; break;
        case 'Add to Definition...': action = ADD_TO_DEFINITION_FROM_SCRATCH; break;
        case 'Functions...': action = FUNCTIONS_MENU_FROM_SCRATCH; break;
        default: action = ''; break;
      }
      return action;
    }
    case ACTION_TYPE_CRGBGRIDMENU: {
      switch (action) {
        case 'Move to Rows': action = MOVE_TO_ROW_FROM_CRB; break;
        case 'Move to Bases': action = MOVE_TO_BASE_FROM_CRB; break;
        case 'Move to Columns': action = MOVE_TO_COLUMN_FROM_CRB; break;
        case 'Copy to Columns': action = COPY_TO_COLUMN_FROM_CRB; break;
        case 'Copy to Rows': action = COPY_TO_ROW_FROM_CRB; break;
        case 'Copy to Bases': action = COPY_TO_BASE_FROM_CRB; break;
        default: action = ''; break;
      }
      return action;
    }
    case ACTION_TYPE_QUESTION: {
      switch (action) {
        case 'Move to Rows': action = MOVE_TO_ROW_FROM_QUESTION; break;
        case 'Move to Bases': action = MOVE_TO_BASE_FROM_QUESTION; break;
        case 'Move to Columns': action = MOVE_TO_COLUMN_FROM_QUESTION; break;
        case 'Move to Scratch': action = ADD_DATAPOINT_TO_SCRATCH; break;
        default: action = ''; break;
      }
      return action;
    }
    case ACTION_TYPE_CUSTOM_DROPDOWN: {
      switch (action) {
        case 'RowsDataGrid': action = ADD_SMARTSEARCH_GRID_ROW; break;
        case 'ColumnsDataGrid': action = ADD_SMARTSEARCH_GRID_COLUMN; break;
        case 'BasesDataGrid': action = ADD_SMARTSEARCH_GRID_BASE; break;
        default: action = ''; break;
      }
      return action;
    }
    case ACTION_TYPE_CRGB_GRIDS: {
      switch (action) {
        case 'ColumnsDataGrid': action = ADD_DICTIONARY_DATA_GRID_COLUMN; break;
        case 'BasesDataGrid': action = ADD_DICTIONARY_DATA_GRID_BASE; break;
        case 'RowsDataGrid': action = ADD_DICTIONARY_DATA_GRID_ROW; break;
        default: action = ''; break;
      }
      return action;
    }
    case ACTION_TYPE_TOOL_GRID: {
      switch (action) {
        case 'BasesDataGrid': action = TOOL_GRID_BASE_EDIT; break;
        case 'ColumnsDataGrid': action = TOOL_GRID_COLUMN_EDIT; break;
        case 'RowsDataGrid': action = TOOL_GRID_ROW_EDIT; break;
        case 'VisaTargetDataGrid': action = TOOL_TARGET_EDIT_CLICK; break;
        case 'DataHaulColumnsDataGrid': action = TOOL_GRID_COLUMN_EDIT; break;
        case 'DataHaulBasesDataGrid': action = TOOL_GRID_BASE_EDIT; break;
        default: action = ''; break;
      }
      return action;
    }
    default: action = ''; break;
  }
  return '';
};

export function getCrosstabData(crosstab) {
  let updatedCrosstab = {
    BasesDataGridData: [],
    ColumnsDataGridData: [],
    RowsDataGridData: [],
  };
  if (crosstab.BasesDataGridData && crosstab.BasesDataGridData.length > 0) {
    updatedCrosstab = {
      ...updatedCrosstab,
      BasesDataGridData: crosstab.BasesDataGridData,
    };
  }
  if (crosstab.ColumnsDataGridData && crosstab.ColumnsDataGridData.length > 0) {
    updatedCrosstab = {
      ...updatedCrosstab,
      ColumnsDataGridData: crosstab.ColumnsDataGridData,
    };
  }
  if (crosstab.RowsDataGridData && crosstab.RowsDataGridData.length > 0) {
    updatedCrosstab = {
      ...updatedCrosstab,
      RowsDataGridData: crosstab.RowsDataGridData,
    };
  }
  return updatedCrosstab;
}

export function isRequestPayloadEmpty(payload) {
  if (Object.keys(payload).length > 0) {
    return false;
  }
  return true;
}

export function getUTCTime() {
  const localTime = new Date().getTime();
  const localOffset = new Date().getTimezoneOffset() * 60000;
  const utc = localTime + localOffset;
  return utc;
}

const checkDiffBtwnDates = oldTimestamp => {
  const oldDateInDays = oldTimestamp / (1000 * 60 * 60 * 24);
  const newDateinDays = getUTCTime() / (1000 * 60 * 60 * 24);
  return (newDateinDays - oldDateInDays) > 30;
};

function checkUnsavedData(currentState) {
  const { crosstab, study } = currentState;
  const timestamp = getUTCTime();
  let requestPayload = {};
  if ((crosstab.BasesDataGridData && crosstab.BasesDataGridData.length > 0) ||
  (crosstab.ColumnsDataGridData && crosstab.ColumnsDataGridData.length > 0) ||
  (crosstab.RowsDataGridData && crosstab.RowsDataGridData.length > 0)) {
    requestPayload = {
      ...requestPayload,
      crosstab: {
        ...getCrosstabData(crosstab),
        products: [study.crosstabStudy.pn],
        weightType: study.crosstabWeightTypes.wt,
        divisor: study.crosstabWeightTypes.dv,
        weightName: study.crosstabWeightTypes.wn,
        customWeights: study.crosstabStudy.cw,
        studyDescription: study.crosstabStudy.sd,
        timestamp,
        toggleCheckValue: crosstab.toggleCheckValue,
      },
    };
  }
  return requestPayload;
}

export const saveUerState = (currentState, uid, accId) => {
  const userStateUrl = `${urls.ROOT_URL}/users/state/${uid}/${accId}`;
  const unsavedData = checkUnsavedData(currentState);
  const dataToSaveInLocalStorage = {
    ...unsavedData,
    crosstab: unsavedData.crosstab ? {
      ...unsavedData.crosstab,
      uid,
      accId,
    } : null,
  };
  if (!isRequestPayloadEmpty(unsavedData)) {
    localStorage.setItem('unsavedData', JSON.stringify(dataToSaveInLocalStorage));
    fetchPolyfill(userStateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(unsavedData),
    }).then(() => {}).catch(error => console.warn(error));
  }
};

export const storeUnsavedData = (currentState, uid, accId) => dispatch => {
  dispatch({ type: IS_USER_STATE_POPUP_SHOWN, hasShown: false });
  dispatch({ type: MANAGE_USER_STATE_POPUP, payload: '' });
  saveUerState(currentState, uid, accId);
};

export function clearUserState(uid, accId, selectedModule) {
  const updatedData = {
    [selectedModule]: null,
  };
  const userStateUrl = `${urls.ROOT_URL}/users/state/${uid}/${accId}`;
  fetchPolyfill(userStateUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updatedData),
  }).then(() => {}).catch(error => console.warn(error));
}

export function showConfirmationBox(userState, localData,
  selectedModule, uid, accId) {
  if (!userState && !localData) {
    return { showUserState: false };
  } if (userState && !localData) {
    return { showUserState: true, data: userState };
  } if (!userState && localData) {
    if (localData.uid === uid && localData.accId === accId) {
      return { showUserState: true, data: localData };
    }
    return { showUserState: false };
  } if (userState && localData) {
    if (localData.uid === uid
      && localData.accId === accId) {
      if (localData.timestamp > userState.timestamp) {
        return { showUserState: true, data: localData };
      }
      return { showUserState: true, data: userState };
    }
    return { showUserState: true, data: userState };
  }
  return { showUserState: false };
}

const generateGridData = (gridData, gridItem) => dispatch => {
  const data = {
    selectedKeywords: [],
    selectedNames: [],
    originalNames: [],
    recTypes: [],
    dataSmartSearch: [],
    isLabelUpdated: [],
  };
  gridData[gridItem].forEach(item => {
    data.selectedKeywords.push(item.keyword);
    data.selectedNames.push(item.title);
    data.originalNames.push(item.originalTitle);
    data.recTypes.push(item.recType || item.rectype || item.type);
    data.dataSmartSearch.push(item.dataSmartSearch);
    data.isLabelUpdated.push(item.isLabelUpdated);
  });
  return data;
};

let userStateData;
const getFormatedUserStateData = (gridData, selectedModule) => dispatch => {
  userStateData = {
    basesGrid: dispatch(generateGridData(gridData, 'BasesDataGridData', false)),
    rowsGrid: dispatch(generateGridData(gridData, 'RowsDataGridData', true)),
    columnsGrid: dispatch(generateGridData(gridData, 'ColumnsDataGridData', true)),
    productNo: gridData.products[0],
    weightType: gridData.weightType,
    weightName: gridData.weightName,
    divisor: gridData.divisor,
    customWeights: gridData.customWeights,
    studyDescription: gridData.studyDescription,
    dataScreen: selectedModule,
    toggleCheckValue: gridData.toggleCheckValue,
  };
};

export const getBreadCrumbsDetails = (uid, accountId, productNo, expressionList, gridType) => dispatch => {
  const url = `${urls.ROOT_URL}/dictionary/label/${uid}/${accountId}/${productNo}`;
  axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: expressionList,
  })
    .then(response =>
      dispatch({
        type: EXPRESSIONS_BREADCRUMBS_LIST,
        payload: response.data.data,
        requestList: expressionList,
        gridType,
      }),
    )
    .catch(response => console.warn(response));
};

export const getDictionaryDetails = ( uid, accountId, productNo, expressionList, gridType ) => dispatch => {
  const url = `${urls.ROOT_URL}/dictionary/detail/${uid}/${accountId}/${productNo}`;
  axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: expressionList,
  })
    .then(response =>
      dispatch({
        type: EXPRESSIONS_DETAILS_LIST,
        payload: response.data.data,
        requestList: expressionList,
        gridType,
      }),
    )
    .catch(response => console.warn(response));
};

export const getLastUnsavedDetails = (token, uid, accId, selectedModule) =>
  dispatch => {
    const url = `${urls.ROOT_URL}/users/state/${uid}/${accId}?module=${selectedModule}`;
    let userLastState;
    axios({
      url,
      method: 'get',
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'json',
      withCredentials: true,
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(response => {
        userLastState = response.data.data;
        const localData = localStorage.getItem('unsavedData');
        let crosstabLocalData = localData && JSON.parse(localData)[selectedModule];
        let hasExpired;
        if (crosstabLocalData) {
          hasExpired = checkDiffBtwnDates(crosstabLocalData.timestamp);
        }
        if (hasExpired) {
          crosstabLocalData = undefined;
          if (localData) {
            let tempLocaldata = JSON.parse(localData);
            tempLocaldata = {
              ...tempLocaldata,
              [selectedModule]: null,
            };
            localStorage.setItem('unsavedData', JSON.stringify(tempLocaldata));
          }
        }
        const confirmationBox = showConfirmationBox(
          userLastState[selectedModule],
          crosstabLocalData,
          selectedModule,
          uid,
          accId);
        if (confirmationBox.showUserState) {
          if (selectedModule === CROSSTAB_CONSTANT) {
            const rowsGrid = dispatch(generateGridData(confirmationBox.data, 'RowsDataGridData', false));
            const columnsGrid = dispatch(generateGridData(confirmationBox.data, 'ColumnsDataGridData', false));

            if (rowsGrid.selectedKeywords && rowsGrid.selectedKeywords.length > 0) {
              dispatch(getBreadCrumbsDetails(
                uid,
                accId,
                confirmationBox.data.products[0],
                rowsGrid.selectedKeywords,
                'RowsGrid',
              ));
              dispatch(
                getDictionaryDetails(
                  uid,
                  accId,
                  confirmationBox.data.products[0],
                  divideJointExpressions(rowsGrid.selectedKeywords),
                  'RowsGrid',
                )
              );
            }
            if (columnsGrid.selectedKeywords && columnsGrid.selectedKeywords.length > 0) {
              dispatch(getBreadCrumbsDetails(
                uid,
                accId,
                confirmationBox.data.products[0],
                columnsGrid.selectedKeywords,
                'ColumnsGrid',
              ));
              dispatch(
                getDictionaryDetails(
                  uid,
                  accId,
                  confirmationBox.data.products[0],
                  divideJointExpressions(columnsGrid.selectedKeywords),
                  'ColumnsGrid',
                )
              );
            }
          }
          dispatch(getFormatedUserStateData(confirmationBox.data, selectedModule, uid, accId));
          dispatch({ type: MANAGE_USER_STATE_POPUP, payload: userStateData });
        } else {
          dispatch({ type: MANAGE_USER_STATE_POPUP, noLastSavedCrosstabFlag: true });
        }
      })
      .catch(() => { dispatch({ type: MANAGE_USER_STATE_POPUP, noLastSavedCrosstabFlag: true }); }
    );
  };

export const discardLastCrosstab = (selectedModule, uid, activeAccountId) => dispatch => {
  if (uid && activeAccountId) {
    if (localStorage.getItem('unsavedData')) {
      let tempLocaldata = JSON.parse(localStorage.getItem('unsavedData'));
      tempLocaldata = {
        ...tempLocaldata,
        [selectedModule]: null,
      };
      localStorage.setItem('unsavedData', JSON.stringify(tempLocaldata));
    }
    clearUserState(
      uid,
      activeAccountId,
      selectedModule
    );
  } else {
    dispatch({ type: IS_USER_STATE_POPUP_SHOWN, module: selectedModule, hasShown: true });
  }
  dispatch({ type: MANAGE_USER_STATE_POPUP, payload: '' });
};

export const openLastCrosstab = selectedModule => (dispatch, getState) => {
  const { login, account, study, crosstab } = getState();
  let sampleWeightedParams = {
    token: login.loginResponse.data.token,
    uid: login.loginResponse.data.uid,
    accountId: account.activeAccountId,
    productNo: userStateData.productNo,
    weightType: userStateData.weightType,
    divisor: userStateData.divisor,
  };

  if (userStateData.basesGrid.selectedKeywords.length > 0) {
    sampleWeightedParams = {
      ...sampleWeightedParams,
      sourceGrid: 'BasesDataGrid',
      targetGrid: 'BasesDataGrid',
      expressionList: userStateData.basesGrid.selectedKeywords,
      selectedNames: userStateData.basesGrid.selectedNames,
      originalNames: userStateData.basesGrid.originalNames,
      recTypes: userStateData.basesGrid.recTypes,
      objSmartSearchArray: userStateData.basesGrid.dataSmartSearch,
      isLabelUpdated: userStateData.basesGrid.isLabelUpdated,
    };
    dispatch(getSampleWeighted(sampleWeightedParams));
  }

  if (userStateData.columnsGrid.selectedKeywords.length > 0) {
    sampleWeightedParams = {
      ...sampleWeightedParams,
      sourceGrid: 'ColumnsDataGrid',
      targetGrid: 'ColumnsDataGrid',
      expressionList: userStateData.columnsGrid.selectedKeywords,
      selectedNames: userStateData.columnsGrid.selectedNames,
      originalNames: userStateData.columnsGrid.originalNames,
      recTypes: userStateData.columnsGrid.recTypes,
      objSmartSearchArray: userStateData.columnsGrid.dataSmartSearch,
      isLabelUpdated: userStateData.columnsGrid.isLabelUpdated,
    };
    dispatch(getSampleWeighted(sampleWeightedParams));
  }

  if (userStateData.rowsGrid.selectedKeywords.length > 0) {
    sampleWeightedParams = {
      ...sampleWeightedParams,
      sourceGrid: 'RowsDataGrid',
      targetGrid: 'RowsDataGrid',
      expressionList: userStateData.rowsGrid.selectedKeywords,
      selectedNames: userStateData.rowsGrid.selectedNames,
      originalNames: userStateData.rowsGrid.originalNames,
      recTypes: userStateData.rowsGrid.recTypes,
      objSmartSearchArray: userStateData.rowsGrid.dataSmartSearch,
      isLabelUpdated: userStateData.rowsGrid.isLabelUpdated,
    };
    dispatch(getSampleWeighted(sampleWeightedParams));
  }
  userStateData.rowsGrid.isLabelUpdated.forEach((item, index) => {
    if (item) {
      const updatedData = {
        index,
        originalTitle: userStateData.rowsGrid.originalNames[index],
        updatedTitle: userStateData.rowsGrid.selectedNames[index],
        keyword: userStateData.rowsGrid.selectedKeywords[index],
        gridCategory: 'RowsDataGrid',
      };
      dispatch({ type: UPDATE_CROSSTAB_TITLE_HEADER, payload: updatedData });
    }
  });
  userStateData.columnsGrid.isLabelUpdated.forEach((item, index) => {
    if (item) {
      const updatedData = {
        index,
        originalTitle: userStateData.columnsGrid.originalNames[index],
        updatedTitle: userStateData.columnsGrid.selectedNames[index],
        keyword: userStateData.columnsGrid.selectedKeywords[index],
        gridCategory: 'ColumnsDataGrid',
      };
      dispatch({ type: UPDATE_CROSSTAB_TITLE_HEADER, payload: updatedData });
    }
  });
  const item = getStudyFromStudies(
    filterStudyList(study.studies, CROSSTAB_FEATUREID),
    userStateData.productNo
  );
  let crosstabWeightTypes = item.cw[0];
  if (item.cw) {
    item.cw.forEach(elems => {
      let dv = elems.dv;
      if (item.sd && item.sd.includes('SimmonsLOCAL')) {
        dv = 1;
      } else {
        dv = elems.dv === undefined ? 1000 : elems.dv;
      }
      if (elems.wt === userStateData.weightType && dv === userStateData.divisor) {
        crosstabWeightTypes = { ...elems, dv };
      }
    });
  }
  const StudyItem = { ...item };
  dispatch(updateModuleStudy('crosstab', StudyItem));
  dispatch(updateWeightType('crosstab', crosstabWeightTypes));

  if (crosstab.toggleCheckValue && userStateData.toggleCheckValue
    && crosstab.toggleCheckValue.row !== userStateData.toggleCheckValue.row) {
    dispatch(updateToggleLabelFlag('row'));
  }

  if (crosstab.toggleCheckValue && userStateData.toggleCheckValue
    && crosstab.toggleCheckValue.column !== userStateData.toggleCheckValue.column) {
    dispatch(updateToggleLabelFlag('column'));
  }

  if (userStateData.productNo !== study.crosstabStudy.pn) {
    const fetchStandardBasetParams = {
      token: login.loginResponse.data.token,
      uid: login.loginResponse.data.uid,
      accountId: account.activeAccountId,
      productNo: item.pn,
    };
    if (!login.loginResponse.data.universityUser) {
      dispatch(fetchStandardBaseList(fetchStandardBasetParams));
    }
  }

  dispatch(discardLastCrosstab(
    selectedModule,
    login.loginResponse.data.uid,
    account.activeAccountId
  ));
};

export const saveLastCrosstab = (selectedModule, handleSaveCrosstab) => dispatch => {
  dispatch(openLastCrosstab(selectedModule));
  handleSaveCrosstab();
};
